import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} daysBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  daysBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalIncome = 0;
  let totalQuantity = 0;
  const excelData = [];
  for (let item = 0; item < daysBalance.length; item++) {
    const balance = daysBalance[item];

    excelData.push({
      order: item + 1,
      createdAt: balance.created_at,
      quantity: balance.count,
      total: balance.total,
    });

    totalIncome += balance.total;
    totalQuantity += balance.count;
  }

  excelData.push({
    order: "",
    createdAt: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });
  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR DIAS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "createdAt",
            outValue: "FECHA",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-dias_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-dias_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/DaysBalance/excel.js